import React from 'react'
import LayoutMain from '../../layouts/LayoutMain'
import MyBlock from '../../UI/block/MyBlock'
import MyBlockHeader from '../../UI/block/MyBlockHeader'
import SubmenuPacks from '../submenu/SubmenuPacks'
import PackBoxesList from './PackBoxesList'
import { useParams } from 'react-router-dom'
import PackBoxesOptions from './options/PackBoxesOptions'

const PackBoxes = () => {

	const { packId } = useParams()

  return (
    <LayoutMain>
		<MyBlock>
			{/* <ul className='submenuTop'>
				<li>
					<Link
						to='qr'
						className='active'
					>
						<FormatListBulletedIcon />
						<span>Партії</span>
					</Link>
				</li>
			</ul> */}
			<SubmenuPacks />
		</MyBlock>
        <MyBlockHeader
            header={'Коробки в партії'}
            isBack={true}
            options={
                <PackBoxesOptions 
					packId={packId}
                />
            }
        />
		<MyBlock>
        	<PackBoxesList 
				packId={packId}
			/>
		</MyBlock>
    </LayoutMain>
  )
}

export default PackBoxes